import { LoadState } from "../../../constants/enums";
import { IHabitationalApplication, initialHabitationalApplicationState as habitationalAppDefaults } from "../../habitationalPolicy/habitationalApplication/habitationalApplicationNew.types";

export interface ILeadHabitationalApplicationState {
  data: IHabitationalApplication;
  loading: LoadState;
}

export const initialLeadHabitationalApplicationState: ILeadHabitationalApplicationState = {
  data: habitationalAppDefaults.data,
  loading: LoadState.NotLoaded,
};
